/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { APP_BASE_HREF } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpRequest, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CoreModule } from './@core/core.module';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthGuard } from './shared/auth-guard.service';
import { NbAuthJWTInterceptor,NB_AUTH_TOKEN_INTERCEPTOR_FILTER } from '@nebular/auth';
// import { FormsModule } from '@angular/forms';
import { ApiService } from './shared/api.service'
// import { SharedModule } from './pages/shared-authpipe.module';
// import { RegisterComponent } from './auth/register/register.component';
// import { RegisteredComponent } from './auth/register/registered.component';
// import { TermsComponent } from './auth/register/terms.component';
import { OTPModule } from './auth/otp/otp.module';
import { TotalCourseListModule } from './auth/totalcourselist/totalcourselist.module';
import {
    NbToastrModule,
  // NbTooltipModule,
  NbSpinnerModule,
  //  NbListModule,
  NbDatepickerModule,
  // NbSelectModule,
  // NbRadioModule ,
  NbDialogModule,
  // NbAlertModule,
  // NbButtonModule,
  // NbCheckboxModule,
  //  NbInputModule
 } from '@nebular/theme';
 import {MatSelectModule} from '@angular/material/select';
 import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field';
 import {NbIconLibraries} from '@nebular/theme';
//  import { changePasswordComponent } from "./auth/changePassword/changePassword.component";
 import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
//  import { ForgotPasswordComponent } from './auth/Forgot-password/forgot-password.component';
//  import { resetPasswordComponent } from './auth/Reset-password/reset-password.component';
// import { RegisterComponent } from './auth/register/register.component';
// import { OtpComponent } from './auth/register/otp.component';

//  import { ResendEmailComponent } from './auth/Forgot-password/resend-email.component';
 import { RouterExtService } from './shared/identifyUrl';
 import { AdminOtpModule } from './admin/admin-otp/admin-otp.module';
// import { InstituteRegisterComponent } from './auth/institute-register/institute-register.component';
import { config } from '../../config';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {MatDialogModule} from '@angular/material/dialog';
import { Ng2TelInputModule } from './shared/ng2-tel-input.directive';
import {QatExamDate} from './admin/application/qatExamDate.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxEchartsModule } from 'ngx-echarts';

//const socketconfig: SocketIoConfig = { url: 'http://93.104.211.51:2', options: {} };
//const socketconfig: SocketIoConfig = { url: 'http://93.104.211.51', options: {reconnection: true,transports: ['websocket'],secure: true} };
//const socketconfig: SocketIoConfig = { url: 'http://sdbi.in:3', options: {} };
//const socketconfig: SocketIoConfig = { url: 'wss://sdbi.in', options: {reconnection: true,transports: ['websocket'],secure: true} };
// const socketconfig: SocketIoConfig = { url: 'https://sdbi.in', options: {reconnection: true,transports: ['websocket'],secure: true} };
const socketconfig: SocketIoConfig = { url: 'http://localhost:3', options: {reconnection: true,transports: ['websocket']} };
@NgModule({ declarations: [AppComponent,
        // OtpComponent,
        // RegisteredComponent,
        // ResendEmailComponent,
        QatExamDate
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        // FormsModule,
        // NbTooltipModule,
        NbSpinnerModule,
        // SharedModule,
        NgbModule,
        ThemeModule.forRoot(),
        CoreModule.forRoot(),
        NbToastrModule.forRoot(),
        // NbListModule,
        NbDatepickerModule.forRoot(),
        // NbSelectModule,
        // NbRadioModule,
        NbDialogModule.forRoot(),
        // NbAlertModule,
        // NbButtonModule,
        // NbCheckboxModule,
        // NbInputModule,
        MatSelectModule,
        OTPModule,
        TotalCourseListModule,
        SocketIoModule.forRoot(socketconfig),
        AdminOtpModule,
        ConfirmDialogModule,
        MatDialogModule,
        Ng2TelInputModule,
        NgxPaginationModule,
        NgxEchartsModule.forRoot({ echarts: () => import('echarts') })], providers: [
        { provide: APP_BASE_HREF, useValue: '/' },
        { provide: HTTP_INTERCEPTORS, useClass: NbAuthJWTInterceptor, multi: true },
        { provide: NB_AUTH_TOKEN_INTERCEPTOR_FILTER, useValue: filterInterceptorRequest },
        AuthGuard,
        ApiService,
        RouterExtService,
        provideHttpClient(withInterceptorsFromDi()),
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } }
    ] })
export class AppModule {
  // The app's <nb-icon icon="..."> usages reference legacy CSS icon fonts
  // directly by class name (nebular-icons' "nb-*", ionicons' "ion-*") — all
  // already loaded globally. Nebular 4+ ships with no default icon pack
  // (that became the opt-in `@nebular/eva-icons` package, which isn't
  // installed here), so every <nb-icon> lookup throws "Default pack is not
  // registered." and silently renders blank. Registering an empty font pack
  // as default makes NbIconComponent apply the icon name straight through as
  // a CSS class, which is exactly what these single-token font-icon classes
  // need.
  //
  // FontAwesome icons need their own packs: FA5 requires TWO classes (a
  // style class like "fas"/"far" plus the glyph class "fa-x"), but
  // NbFontIcon.getClasses() always returns the `icon` value as a single
  // array element, and Renderer2.addClass() calls classList.add() — which
  // throws on any string containing a space. So icon="fas fa-x" silently
  // fails to render anything. Fixed by registering "fas"/"far" as their own
  // packs with `packClass`, so the two classes come out as two separate
  // (valid) addClass calls — used via icon: { icon: 'x', pack: 'fas' }.
  constructor(iconLibraries: NbIconLibraries) {
    iconLibraries.registerFontPack('legacy-fonts', {});
    iconLibraries.registerFontPack('fas', { packClass: 'fas', iconClassPrefix: 'fa' });
    iconLibraries.registerFontPack('far', { packClass: 'far', iconClassPrefix: 'fa' });
    iconLibraries.registerFontPack('fab', { packClass: 'fab', iconClassPrefix: 'fa' });
    iconLibraries.setDefaultPack('legacy-fonts');
  }
}
export function filterInterceptorRequest(req: HttpRequest<any>) {
  return [config.serverUrl+'/api/auth/',
         ]
    .some(url => req.url.includes(url));
}
